import React, { useEffect, useMemo, useRef, useState } from 'react'
import { ScheduleComponent, Day, Week, Month, Inject, ResourcesDirective, ResourceDirective, ViewsDirective, ViewDirective } from '@syncfusion/ej2-react-schedule';
import Loader from "../../../component/Loader.jsx"
import { useSelector } from 'react-redux';
import { CoachSchedulerAPI } from '../../../api/CoachSchedulerAPI.js';
import { onActionComplete, onEventClick, onPopupOpen, onSingleClick } from './CoachScheduleActions.js';
import { SubscriptionAPI } from '../../../api/SubscriptionAPI.js';
import { CalendarAPI } from '../../../api/CalendarAPI.js';
import { getWorkingDays } from './SchedulerConfigFunctions.js';
import { getMaximunmTimeInADay, handleTimeOparetionsPerDay, setInitialStartAndEndHour } from '../../../util/CalendarUtil.js';
import { useDispatch } from 'react-redux';
import { calenderAction } from '../../../redux/reducer/calenderReducer.js';
import SchedulerEventTemplate, { mountSchedulerEventCard } from './SchedulerEventTemplate.jsx';
import { calendarSlotInterval, clubCalendarTimezone, hoursForSchedulerView, nowInClubTimezone, schedulerEventColors, toScheduleDate } from './schedulerForm.js';
import { EventAPI } from '../../../api/EventAPI.js'
import { Privileges } from '../../../util/PrivilegeConstants.js';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI.js';
import { isUser } from '../../../util/UserRoles.js';
import { clubHasMemberPlans, isCalendarBlockedBySubscription, schedulerActiveView, schedulerMonthMaxEvents, schedulerShowsCourtGroup, shouldShowCalendarSubscriptionMask } from '../../../util/calendarAccess.js';
import { ProductAPI } from '../../../api/ProductAPI.js';
import SchedulerEditorDialog from './SchedulerEditorDialog.jsx';


const CoachScheduler = () => {

    const scheduleRef = useRef(null);
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [events, setEvents] = useState([]);
    const [scheduleData, setScheduleData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [calenderConfig, setCalenderConfig] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);
    const [privileges, setPrivileges] = useState({});
    const [isCheckoutEnable, setIsCheckoutEnable] = useState(false);
    const [scheduleConfigData, setScheduleConfigData] = useState({
        isUserInvalidToAccess: false,
        game: {},
        resourceData: [],
        courtData: [],
        players: [],
        workingDays: []
    })
    const [loadingState, setLoadingState] = useState({
        loading1: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
    });
    const [currentSelectedDate, setCurrentSelectedDate] = useState('');
    const [editorSession, setEditorSession] = useState(null);
    const {
        currentView, weekDayStartTime, weekDayEndTime, dayStartTime, currentGameId,
        dayEndTime, startHour, endHour
    } = useSelector((store) => store.calendar);
    const dispatch = useDispatch();
    const collectScheduleConfig = (key, data) => {
        setScheduleConfigData((prev) => ({
            ...prev,
            [key]: data
        }))
    };
    const startLoading = (key) => {
        setLoadingState((prev) => ({
            ...prev,
            [key]: true
        }))
    };

    const finishLoading = (key) => {
        setLoadingState((prev) => ({
            ...prev,
            [key]: false
        }))
    };
    const findCalendarConfigCheckout = async () => {
        try {
            const response = await CalendarAPI.getCalendarConfigCheckout(selectedClub.clubId);
            setIsCheckoutEnable(response.Data);
        } catch (error) {
            console.log(error);
        }
    };

    const findAllEvent = async () => {
        try {
            startLoading("loading1")
            const response = await EventAPI.getAllEventForListOptions(selectedClub.clubId, userInfo.userId);
            setEvents(response.Data);

        } catch (error) {
            console.error(error);

        } finally {
            finishLoading("loading1")
        }
    }

    const findAllPrivileges = async () => {
        try {
            startLoading()
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[6]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.error(error);
        } finally {
            finishLoading();
        }
    };
    const transformScheduleData = (data) => {
        //console.log(data);

        return {
            Id: data.scheduleId,
            Subject: data.subject,
            IsReadonly: data.scheduleType === 'BLACK_OUT_DATE',
            StartTime: toScheduleDate(data.scheduleStartTime),
            EndTime: toScheduleDate(data.scheduleEndTime),
            Description: data.scheduleDescription,
            Venue: data.venue,
            EventId: data.eventId,
            AwayOrgId: data.awayOrgId,
            HomeTeamId: data.scheduleType === "EVENT" ? data.homeTeamId : "",
            AwayTeamId: data.scheduleType === "EVENT" ? data.awayTeamId : "",
            ScheduleType: data.scheduleType,
            RecurrenceRule: data.recurrenceRule,
            TeamIds: data.teamIds,
            AwayTeamName: data.awayTeamName,
            AwayOrganizationName: data.awayOrganizationName,
            RecurrenceID: data.recurrenceId,
            SeriesId: data.recurrenceId,
            CourtNumber: data.resourceId ?? null,
            hideRecurrenceEditor: true,
            editEntireSeries: false,
            MeetingData: data.meetingData,
            AcceptedUser: data.acceptedUser ?? 0,
            PendingUser: data.pendingUser ?? 0,
            IsRSVP: data.rsvp ?? data.isRSVP ?? false,
            MaxSlot: data.maxSlot ?? 0,
            ScheduleCreatedBy: data.scheduleCreatedBy,
            IsPaid: data.isPaid,
            IsAttachAllMember: data.isAttachAllMember ?? data.attachAllMember ?? false,
            Status: data.scheduleStatus,
            IsAttachAllGuest: data.isAttachAllGuest ?? data.attachAllGuest ?? false,
            IsAwayOrgRegistered: Boolean(data.awayOrgId),
            ...schedulerEventColors(
                data.scheduleType,
                scheduleConfigData.courtData?.find((item) => item.id === (data.resourceId ?? scheduleConfigData.courtData[0]?.id))?.color
            )
        }
    };
    const fetchSchedulesForRange = async (startTime, endTime) => {
        if (!startTime || !endTime || !currentGameId || !selectedClub?.clubId) {
            return;
        }
        try {
            startLoading("loading3");
            const response = await CoachSchedulerAPI.findAllCoachSchedule({
                gameId: currentGameId,
                startTime,
                endTime,
                clubId: selectedClub.clubId,
                clientTimeZone: clubCalendarTimezone(calenderConfig),
                userId: userInfo.userId
            });
            setScheduleData((response.Data || []).map((data) => transformScheduleData(data)));
        } catch (error) {
        } finally {
            finishLoading("loading3");
        }
    };
    const fetchSchedulesForDay = async () => fetchSchedulesForRange(dayStartTime, dayEndTime);
    const fetchSchedulesForWeek = async () => fetchSchedulesForRange(weekDayStartTime, weekDayEndTime);
    const fetchSchedulesForCurrentView = async () => {
        const dates = scheduleRef.current?.getCurrentViewDates?.();
        if (dates?.length) {
            const start = new Date(dates[0]).setHours(0, 0, 0, 0);
            const end = new Date(dates[dates.length - 1]).setHours(23, 59, 59, 999) + 1000;
            await fetchSchedulesForRange(start, end);
            return;
        }
        const view = schedulerActiveView(currentView);
        if (view === 'Day') {
            await fetchSchedulesForDay();
            return;
        }
        await fetchSchedulesForWeek();
    };

    const initializedClubRef = useRef(null);
    useEffect(() => {
        if (!calenderConfig || !selectedClub?.clubId) {
            return;
        }
        if (initializedClubRef.current === selectedClub.clubId) {
            return;
        }
        initializedClubRef.current = selectedClub.clubId;
        setInitialStartAndEndHour(dispatch, calenderConfig, isUser(userInfo));
        setSelectedDate(nowInClubTimezone(calenderConfig));
    }, [calenderConfig, selectedClub?.clubId])

    useEffect(() => {
        if (selectedClub?.clubId) {
            fetchAllAPI();
            fetchIsSubscriptionPurchased();
            findAllPrivileges();
            findCalendarConfigCheckout();
        }
    }, [selectedClub?.clubId]);

    useEffect(() => {
        if (!scheduleRef.current || !selectedDate) {
            return;
        }
        const dates = scheduleRef.current.getCurrentViewDates();
        setCurrentSelectedDate((prev) => {
            const prevKey = prev?.[0]?.getTime?.();
            const nextKey = dates?.[0]?.getTime?.();
            return prevKey === nextKey ? prev : dates;
        });
    }, [selectedDate, calenderConfig]);

    useEffect(() => {
        findAllEvent();
    }, []);


    useEffect(() => {
        if (!currentGameId) {
            return;
        }
        const view = schedulerActiveView(currentView);
        if (view === 'Day') {
            if (!dayStartTime) {
                return;
            }
            fetchSchedulesForDay();
            return;
        }
        if (view === 'Month') {
            fetchSchedulesForCurrentView();
            return;
        }
        if (!weekDayStartTime) {
            return;
        }
        fetchSchedulesForWeek();
    }, [currentGameId, selectedClub?.clubId, dayStartTime, weekDayStartTime, currentView]);

    useEffect(() => {
        if (!isRefresh || !currentGameId) {
            return;
        }
        fetchSchedulesForCurrentView();
        setIsRefresh(false);
    }, [isRefresh]);


    const fetchIsSubscriptionPurchased = async () => {
        try {
            startLoading("loading4");
            let memberPlans = false;
            try {
                const products = await ProductAPI.getAllProducts(userInfo?.userId, selectedClub?.clubId);
                memberPlans = clubHasMemberPlans(products?.Data);
            } catch (error) {
                memberPlans = false;
            }
            collectScheduleConfig("hasMemberPlans", memberPlans);
            const res = await SubscriptionAPI.isSubscriptionPurchased(userInfo?.userId, selectedClub?.clubId);
            collectScheduleConfig("isUserInvalidToAccess", isCalendarBlockedBySubscription({
                purchased: res?.Data === true,
                userInfo,
                selectedClub,
                hasMemberPlans: memberPlans,
            }));
        } catch (error) {
        } finally {
            finishLoading("loading4")
        }
    }
    const fetchAllAPI = async () => {
        try {
            startLoading("loading5")
            const apiCalls = [
                CalendarAPI.getCalendarConfig(selectedClub?.clubId),
                CalendarAPI.getAllResourceAndGame({ clubId: selectedClub?.clubId }),
                CoachSchedulerAPI.findPlayerTeamDetails(selectedClub?.clubId, userInfo.userId),
            ];


            const [
                calendarConfig,
                allGames,
                allUsersForAClub
            ] = await Promise.allSettled(apiCalls);


            // Extract responses based on the presence of getAdvanceBooking
            if (calendarConfig.status === "fulfilled") {
                setCalenderConfig(calendarConfig.value.Data)
                collectScheduleConfig("workingDays", getWorkingDays(calendarConfig.value.Data));
            }
            if (allGames.status === "fulfilled") {
                dispatch(calenderAction.setCurrentGameId(allGames.value.Data.games[0]?.gameId))
                collectScheduleConfig("game", allGames.value.Data.games);
                let data = allGames.value.Data.resources;
                const result = data?.map((item) => ({
                    Name: item?.courtNumber,
                    Id: item?.id,
                    Color: item?.color,
                }));
                collectScheduleConfig("resourceData", result);
                collectScheduleConfig("courtData", data);
            }
            if (allUsersForAClub.status === "fulfilled") {
                collectScheduleConfig("players", allUsersForAClub.value.Data);
            }
        } catch (error) {
            console.log(error);

        } finally {
            finishLoading("loading5")
        }

    }



    const boardView = schedulerActiveView(currentView);
    const slotInterval = calendarSlotInterval(calenderConfig);
    const boardHours = hoursForSchedulerView(calenderConfig, boardView, selectedDate);
    const eventSettings = useMemo(() => ({
        dataSource: scheduleData,
        ignoreWhitespace: false,
        template: (props) => SchedulerEventTemplate(props, boardView),
    }), [scheduleData, boardView]);

    const paintEventCards = () => {
        const schedule = scheduleRef.current;
        if (!schedule?.element) {
            return;
        }
        schedule.element.querySelectorAll('.e-appointment').forEach((element) => {
            const data = schedule.getEventDetails?.(element);
            if (data) {
                mountSchedulerEventCard(element, data, boardView);
            }
        });
    };

    const onEventRendered = (args) => {
        mountSchedulerEventCard(args.element, args.data, boardView);
    };

    if (loadingState.loading1 || loadingState.loading4 || loadingState.loading5) {
        return <Loader />;
    }

    const groupData = {
        resources: ['Resources']
    }

    return (
        <>
            {(loadingState.loading3 || loadingState.loading2) && <Loader />}
            {(selectedClub?.clubId && calenderConfig && selectedDate) &&
                <div className='sm_coach_scheduler_container'>
                    {shouldShowCalendarSubscriptionMask({
                        blockedBySubscription: scheduleConfigData.isUserInvalidToAccess,
                        userInfo,
                        selectedClub,
                        hasMemberPlans: scheduleConfigData.hasMemberPlans,
                    }) &&
                        <div className='security-mask-on-schedule'>
                            <p>To access the calendar, please purchase a subscription.</p>
                        </div>}
                    <ScheduleComponent height='80dvh'
                        ref={scheduleRef}
                        cssClass={`sm-scheduler-board ${slotInterval === 60 ? 'sm-interval-60' : 'sm-interval-30'}`}
                        delayUpdate={false}
                        selectedDate={selectedDate}
                        showTimeIndicator={false}
                        showQuickInfo={false}
                        eventSettings={eventSettings}
                        eventRendered={onEventRendered}
                        dataBound={paintEventCards}
                        timeScale={{ interval: slotInterval, slotCount: 1 }}
                        cellDoubleClick={(args) => { args.cancel = true }}
                        eventDoubleClick={(args) => { args.cancel = true }}
                        cellClick={(args) => onSingleClick(args, scheduleRef, privileges, setEditorSession, shouldShowCalendarSubscriptionMask({
                            blockedBySubscription: scheduleConfigData.isUserInvalidToAccess,
                            userInfo,
                            selectedClub,
                            hasMemberPlans: scheduleConfigData.hasMemberPlans,
                        }))}
                        eventClick={(args) => onEventClick(args, scheduleRef, userInfo, calenderConfig, privileges, setEditorSession)}
                        popupOpen={(args) => onPopupOpen(args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig,privileges)}
                        actionComplete={(args) => {
                            onActionComplete(args, scheduleRef, dispatch);
                            if (args.requestType === 'dateNavigate' || args.requestType === 'viewNavigate') {
                                const dates = scheduleRef.current?.getCurrentViewDates?.();
                                if (dates?.[0]) {
                                    setSelectedDate(new Date(dates[0]));
                                }
                            }
                        }}
                        startHour={boardHours.startHour}
                        endHour={boardHours.endHour}
                        workDays={scheduleConfigData.workingDays?.length ? scheduleConfigData.workingDays : [0, 1, 2, 3, 4, 5, 6]}
                        showWeekend={true}
                        currentView={boardView}
                        rowAutoHeight={false}
                        timezone='UTC'
                        group={schedulerShowsCourtGroup(scheduleConfigData?.resourceData) ? groupData : null}
                    >
                        <ViewsDirective>
                            <ViewDirective option="Day" />
                            <ViewDirective option="Week" />
                            <ViewDirective option="Month" maxEventsPerRow={schedulerMonthMaxEvents()} />
                        </ViewsDirective>
                        {schedulerShowsCourtGroup(scheduleConfigData?.resourceData) &&
                            <ResourcesDirective>
                                <ResourceDirective field='CourtNumber' title='Court Number' name='Resources' textField='Name' idField='Id' colorField='Color' dataSource={scheduleConfigData.resourceData} />
                            </ResourcesDirective>}
                        <Inject services={[Day, Week, Month]} />
                    </ScheduleComponent>
                    {editorSession &&
                        <SchedulerEditorDialog
                            session={editorSession}
                            userInfo={userInfo}
                            selectedClub={selectedClub}
                            events={events}
                            courtData={scheduleConfigData.courtData}
                            calenderConfig={calenderConfig}
                            players={scheduleConfigData.players}
                            privileges={privileges}
                            scheduleRef={scheduleRef}
                            setIsRefresh={setIsRefresh}
                            dispatch={dispatch}
                            onClose={() => setEditorSession(null)}
                        />}
                </div>
            }
        </>

    );
}

export default CoachScheduler